import React, { useCallback, useEffect, useState } from "react";
import {
  Configure,
  connectSearchBox,
  MenuSelect,
} from "react-instantsearch-dom";
import { SearchBoxProvided } from "react-instantsearch-core";
import { FormButton } from "../CatalogSearch/FormButton";
import { FormSelect } from "../CatalogSearch/FormSelect";
import * as styles from "./SiteSearchResults.module.css";
import { useBreakpoint } from "gatsby-plugin-breakpoints";

interface Props extends SearchBoxProvided {
  delay: number;
  placeHolder: string;
  handleAdvancedClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  includeContentCategory?: boolean;
  contentCategoryTitle?: string;
  includePageType?: boolean;
  pageTypeTitle?: string;
  includeRelevancyTags?: boolean;
  relevancyTagsTitle?: string;
}

const CustomAdvancedSearchBox = (props: Props) => {
  const breakpoints = useBreakpoint();
  const {
    refine,
    delay,
    handleAdvancedClick,
    includeContentCategory,
    includePageType,
    includeRelevancyTags,
    relevancyTagsTitle,
    contentCategoryTitle,
    pageTypeTitle,
  } = props;

  const [searchRows, setSearchRows] = useState(["row0"]);
  const [advSearchValues, setAdvSearchValues] = useState({
    row0: {
      text: props.currentRefinement,
    },
  });

  const [restrictSearchableAttributes, setRestrictSearchableAttributes] =
    useState(undefined as string[] | undefined);

  const handleAddRowClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setSearchRows([...searchRows, `row${searchRows.length}`]);
  };

  const handleSearchSubmit = (event?: React.FormEvent<HTMLFormElement>) => {
    event?.preventDefault();

    let queryString = "";

    Object.keys(advSearchValues).forEach((row, idx) => {
      const rowQuery = advSearchValues[row];
      const parameter = rowQuery.parameter;
      const value = rowQuery.text;

      if (row === "row0") {
        rowQuery.attribute
          ? setRestrictSearchableAttributes([rowQuery?.attribute])
          : setRestrictSearchableAttributes(undefined);
      }

      if (!value) return;

      switch (parameter) {
        case "excludes":
          queryString += "-" + `"${value}" `;
          break;
        case "is":
          queryString += `"${value}" `;
          break;
        default:
          queryString += value + " ";
      }
    });

    refine(queryString.trim());
  };

  const handleClearSearchClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    refine("");
    setAdvSearchValues({
      row0: {
        text: "",
      },
    });
    setSearchRows(["row0"]);
  };

  const handleSearchChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    let newSearchValues = { ...advSearchValues };

    const row = event.target?.name.split("-")[0];
    const field = event.target.name.split("-")[1];
    const value = event.target.value;

    if (newSearchValues[row]) {
      newSearchValues[row][field] = value;
    } else {
      newSearchValues[row] = {
        [field]: value,
      };
    }

    setAdvSearchValues(newSearchValues);
  };

  const renderSearchRows = () =>
    searchRows.map((row) => (
      <div className={styles.advSearchRow} key={row}>
        {row === "row0" ? (
          <FormSelect
            className={styles.selectBox}
            name={row + "-attribute"}
            id={row + "-attribute"}
            register={{
              value: advSearchValues[row]?.attribute || "any",
              onChange: handleSearchChange,
            }}
          >
            <option value="any">Any field</option>
            <option value="title">Title</option>
            <option value="content">Content</option>
          </FormSelect>
        ) : (
          <div className={styles.filterTitle}>and </div>
        )}
        <FormSelect
          className={styles.selectBox}
          name={row + "-parameter"}
          id={row + "-paramter"}
          register={{
            value: advSearchValues[row]?.parameter || "contains",
            onChange: handleSearchChange,
          }}
        >
          <option value="contains">contains</option>
          <option value="is">contains exactly</option>
          <option value="excludes">does not contain</option>
        </FormSelect>{" "}
        <input
          type="text"
          name={row + "-text"}
          id={row + "-text"}
          value={advSearchValues[row]?.text || ""}
          onChange={handleSearchChange}
        ></input>
      </div>
    ));

  return (
    <div className="ais-SearchBox">
      <Configure
        advancedSyntax={true}
        restrictSearchableAttributes={restrictSearchableAttributes}
      />
      <form
        noValidate
        className="ais-SearchBox-form"
        action=""
        onSubmit={handleSearchSubmit}
        role="search"
      >
        {/* <div className={styles.searchContainer}>
          <input
            placeHolder="Search the site..."
            delay={200}
            name={"default-text"}
            id={"default-text"}
            value={advSearchValues["default"]?.text || ""}
            onChange={handleSearchChange}
          />
        </div> */}
        <div className={styles.advancedSearch}>
          {!breakpoints.l && (
            <div className={styles.categoryRefinement}>
              {includeContentCategory && (
                <MenuSelect
                  attribute="contentCategory"
                  translations={{
                    seeAllOption: contentCategoryTitle || "Content Category",
                  }}
                  limit={50}
                  className={`${styles.selectBox} ${styles.fullWidth}`}
                ></MenuSelect>
              )}
              {includePageType && (
                <MenuSelect
                  attribute="pageType"
                  translations={{
                    seeAllOption: pageTypeTitle || "Page Type",
                  }}
                  limit={50}
                  className={`${styles.selectBox} ${styles.fullWidth}`}
                ></MenuSelect>
              )}
              {includeRelevancyTags && (
                <MenuSelect
                  attribute="relevancyTags"
                  translations={{
                    seeAllOption: relevancyTagsTitle || "Relevancy Tags",
                  }}
                  limit={50}
                  className={`${styles.selectBox} ${styles.fullWidth}`}
                ></MenuSelect>
              )}
            </div>
          )}
          {renderSearchRows()}
          {/* <div className={styles.advSearchRow}>
							<div className={styles.advancedBtnWrap}>
								<button
									onClick={handleAdvancedClick}
									className={styles.advancedBtn}
									type="button">
									<span>- </span>
									<span>SIMPLE SEARCH</span>
								</button>
						</div>
					</div> */}
          <div className={styles.advSearchRow + " " + styles.buttonRow}>
            <div>
              <FormButton onClick={handleAddRowClick}>Add Row</FormButton>{" "}
            </div>
            <div className={styles.searchButtons}>
              <FormButton onClick={handleClearSearchClick} type={"reset"}>
                Clear
              </FormButton>{" "}
              <FormButton invert={true} type={"submit"}>
                Search
              </FormButton>
              <div className={styles.advancedBtnWrap}>
                <button
                  onClick={handleAdvancedClick}
                  className={styles.advancedBtn}
                  type="button"
                >
                  <span>- </span>
                  <span>SIMPLE SEARCH</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

const AdvancedSearch = connectSearchBox(CustomAdvancedSearchBox);

export default AdvancedSearch;
